import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { ItemLocation } from "@coworker/apprestructured/src/shared/components/item-cards/ItemLocation/ItemLocation";
import React from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../styles/testbuy-common-styles.module.css";

interface CustomTestbuyAddItemCardProps {
  item: Item;
  homeLocationGridCode: string;
}

export const CustomTestbuyAddItemCard = ({
  item,
  homeLocationGridCode,
}: CustomTestbuyAddItemCardProps) => {
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          <Spacer />
          {homeLocationGridCode !== "no_location" && (
            <ItemLocation locationGridCode={homeLocationGridCode} />
          )}
        </div>
      </div>
    </ItemCard>
  );
};
